import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss']
})
export class ImageViewComponent extends ComponentBase implements OnInit {
  constructor() { super(); }

  ngOnInit() {}

  get imageWidth(): string | null {
    const widthOpt = this.attribute.options?.find(opt => opt.key.toLowerCase() === 'width');
    return widthOpt ? widthOpt.value : null;
  }

  get imageHeight(): string | null {
    const heightOpt = this.attribute.options?.find(opt => opt.key.toLowerCase() === 'height');
    return heightOpt ? heightOpt.value : null;
  }
} 